import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EStampRoutingModule } from './e-stamp-routing.module';
import { EStampParentComponent } from './e-stamp-parent/e-stamp-parent.component';
import { EStampFormComponent } from './e-stamp-form/e-stamp-form.component';
import { SharedComponentsModule } from 'src/app/shared-components/shared-components.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@NgModule({
  declarations: [
    EStampParentComponent,
    EStampFormComponent,
    
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    EStampRoutingModule,
    SharedComponentsModule
  ]
})
export class EStampModule { }
